"use strict";
/* eslint-disable functional/prefer-readonly-type */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAbsoluteDiscountedPrice = exports.promoCodeToDiscountDisplayText = exports.packageToDiscountWithMonitoringDisplayText = exports.packageToDiscountDisplayText = exports.discountToAbsoluteAmount = exports.discountToRelativeAmount = exports.simplifyProductDiscountedPrice = void 0;
const verifyMaybe_1 = __importDefault(require("@simplisafe/ewok/monet-utils/verifyMaybe"));
const monda_1 = require("@simplisafe/monda");
const monet_1 = require("monet");
const prop_1 = __importDefault(require("ramda/src/prop"));
const subtract_1 = __importDefault(require("ramda/src/subtract"));
const price_1 = require("./price");
/** Format CT price object array into a simplified price */
const simplifyProductDiscountedPrice = (product) => (0, monda_1.safeProp)('masterVariant', product)
    .chain((0, monda_1.safeProp)('price'))
    .chain((0, monda_1.safeProp)('discounted'))
    .chain((0, monda_1.safeProp)('value'))
    .map(price_1.formatCTPriceToNumber);
exports.simplifyProductDiscountedPrice = simplifyProductDiscountedPrice;
function isRelative(val) {
    return val.type === 'relative';
}
function isAbsolute(val) {
    return val.type === 'absolute';
}
/**
 * Converts a discount into a relative discount amount (as a percentage).
 * Return None if it's 0%.
 */
function discountToRelativeAmount(discount) {
    return discount.chain((val) => isRelative(val)
        ? monet_1.Maybe.fromUndefined(val)
        : (0, monet_1.None)())
        .chain((0, monda_1.safeProp)('permyriad'))
        .filter(value => value > 0)
        .map(n => n / 100);
}
exports.discountToRelativeAmount = discountToRelativeAmount;
/**
 * Converts a discount into an absolute discount amount.
 * Return None if it's a value of 0.
 */
function discountToAbsoluteAmount(discount) {
    return discount.chain((val) => isAbsolute(val)
        ? monet_1.Maybe.fromUndefined(val.money)
        : (0, monet_1.None)())
        // TODO: what happens when we have more than 1? Can this have more than 1 value?
        .chain(monda_1.safeHead)
        .filter(money => (0, prop_1.default)('centAmount', money) > 0)
        // val as RawPrice is needed because CT's types are wrong
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        .map(val => (0, price_1.formatCTPriceToNumber)(val));
}
exports.discountToAbsoluteAmount = discountToAbsoluteAmount;
/**
 * Accept locale & package, parse out display string for non-service promo discount
 * eg "$35" or "20%"
 */
const packageToDiscountDisplayText = (locale) => (_package) => _package.absoluteDiscount
    .chain((0, price_1.localizedDisplayPrice)(locale, { notation: 'compact' }))
    .catchMap(() => _package.relativeDiscount
    .map(percentage => percentage + '%'));
exports.packageToDiscountDisplayText = packageToDiscountDisplayText;
/**
 * Accept locale & package, parse out display string for discount with interactive monitoring
 * eg "$35" or "20%"
 */
const packageToDiscountWithMonitoringDisplayText = (locale) => (_package) => _package.absoluteDiscountWithServicePlan
    .chain((0, price_1.localizedDisplayPrice)(locale, { notation: 'compact' }))
    .catchMap(() => _package.relativeDiscountWithServicePlan
    .map(percentage => percentage + '%'));
exports.packageToDiscountWithMonitoringDisplayText = packageToDiscountWithMonitoringDisplayText;
/**
 * Accept locale & package, parse out display string for non-service promo discount
 * eg "$35" or "20%"
 */
const promoCodeToDiscountDisplayText = (locale) => (promoCode) => promoCode.absoluteDiscount
    .chain((0, price_1.localizedDisplayPrice)(locale, { notation: 'compact' }))
    .catchMap(() => promoCode.relativeDiscount
    .map(percentage => percentage + '%'));
exports.promoCodeToDiscountDisplayText = promoCodeToDiscountDisplayText;
/**
 * Returns a discounted product price if absolute discount value is set
 */
const getAbsoluteDiscountedPrice = (discounts) => (price) => (0, monda_1.safeProp)('absoluteDiscount', discounts)
    .chain(verifyMaybe_1.default)
    .map((0, subtract_1.default)(price))
    .getOrElse(price);
exports.getAbsoluteDiscountedPrice = getAbsoluteDiscountedPrice;
//# sourceMappingURL=discounts.js.map